<script lang="ts">
import { OtherDealsPopup } from "./other-deals-popup";

export default OtherDealsPopup;
</script>

<template>
    <Dialog
        v-model:visible="model.show"
        :modal="true"
        :dismissableMask="true"
        :showHeader="false"
        :breakpoints="{ '649px': '90vw' }"
        contentStyle="overflow: overlay; padding: 0px; background-color: transparent;"
        style="width: 62.5rem"
    >
        <div v-if="model.show" class="content">
            <img src="/img/close-btn.svg" class="close-popup-btn" @click="close" />

            <div class="message">
                <img src="/img/checkbox-select.svg" />
                {{ message }}
            </div>

            <div class="buttons">
                <router-link :to="viewLink" class="button" type="button" @click="close">
                    {{ viewButtonText }}
                </router-link>
                <button @click="close" class="button button--outline-blue">
                    {{ i18n.t("otherDealsPopup.continueShopping") }}
                </button>
            </div>

            <div v-if="model.cars.length">
                <div class="title">{{ i18n.t("otherDealsPopup.title") }}</div>
                <div class="cars">
                    <vehicle-group-tile
                        source="vehicles-grouped"
                        :filters="getVehicleFilterQueryParameters"
                        class="wow fadeIn"
                        data-wow-offset="100"
                        v-for="groupDto in model.cars"
                        :key="groupDto.hashcode"
                        :group-dto="groupDto"
                        @close-popup="close"
                    ></vehicle-group-tile>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<style scoped src="./other-deals-popup.css"></style>
